import { TextArea } from "@/components";
import { Box, Text } from "@chakra-ui/react";
import { CustomText, Wrapper } from "./termModalContent.style";

export const TermModalContent = ({ title, contents }: { title: string; contents: string }) => {
    const privacy = title === "개인정보 이용 방침";
    // const validateText = contents.replace(/nbsp;|amp;|&|<\/?[^br]+(>)/g, "");
    return (
        <Wrapper>
            <CustomText>{title}</CustomText>
            <Box overflow="scroll" flex={"1"} textAlign="left">
                {privacy ? (
                    <TextArea content={contents} />
                ) : (
                    <Text
                        dangerouslySetInnerHTML={{ __html: contents }}
                        sx={{
                            "& div": {
                                textAlign: "left",
                            },
                        }}
                    ></Text>
                )}
            </Box>
        </Wrapper>
    );
};
